import React from 'react';
import { Card, CardHeader, CardBody, CardTitle } from "reactstrap";
import { useTranslation } from 'react-i18next';
import {chartExample4} from "../../variables/charts.js";
import { Line, Bar } from "react-chartjs-2";

const EmailsHistogram = () => {
  const { t } = useTranslation();
  const [bigChartData, setbigChartData] = React.useState("data2");
  const setBgChartData = (name) => {
    setbigChartData(name);
  };
  return (
    <Card className="card-chart">
        <CardHeader>
        <h5 className="card-category" style={{cursor:"default"}}>{t('Completed_Tasks')}</h5>
        <CardTitle tag="h3" style={{cursor:"default"}}>
            <i className="tim-icons icon-send text-success" /> 12,100K
        </CardTitle>
        </CardHeader>
        <CardBody>
        <div className="chart-area">
            <Line
            data={chartExample4.data}
            options={chartExample4.options}
            />
        </div>
        </CardBody>
    </Card>
  );
};

export default EmailsHistogram;